<template>
  <div class="CardHouses">
    <div v-for="(item, index) in indexThis.housesList" :key="index" class="card" :class="{ active: index === indexThis.housesIndex }" @click="select(index)">
      <div class="col">
        <span class="label">项目：</span>
        <span>{{ getCommunityName(item.communityId) }}</span>
      </div>
      <div class="col">
        <span class="label">房屋编号：</span>
        <span>{{ item.buildingRoomCode }}</span>
      </div>
      <div class="col">
        <span class="label">姓名：</span>
        <span>{{ item.householdName }}</span>
      </div>
      <img src="@/assets/image/home.png" class="home" />
    </div>
    <div v-if="indexThis.housesList.length === 0" class="empty">
      <img src="@/assets/image/homeLogo.png" class="homeLogo" />
      <div>该业主信息未录入，请填写住户信息表单，提交录入</div>
    </div>
  </div>
</template>

<script>
import { getCommunityName } from '@/utils/auth'

export default {
  inject: ['indexThis'],
  data() {
    return {}
  },
  methods: {
    select(index) {
      this.indexThis.$refs.Drawer.activeName = '1'
      this.indexThis.housesIndex = index
      this.$nextTick(() => this.indexThis.$refs.Drawer.$refs.CardWorkAdd.init())
    },
  },
}
</script>

<style lang="scss" scoped>
.active {
  background: linear-gradient(135deg, #005eff 0%, #5292ff 100%);
  border: 1px solid #165dff !important;
  color: #fff !important;
}
.CardHouses {
  display: flex;
  .card {
    padding: 8px 16px 0 16px;
    font-size: 14px;
    margin: 0 24px 24px 0;
    border-radius: 16px;
    border: 1px solid #97beff;
    background-color: #ecf3ff;
    width: 200px;
    color: #5795fd;
    position: relative;
    .home {
      position: absolute;
      bottom: 6px;
      right: 6px;
      padding: 4px;
      border-radius: 30px 30px 8px 30px;
      background-color: #cde0ff;
      height: 24px;
      width: 24px;
    }
    .col {
      padding-bottom: 8px;
      font-weight: 700;
      .label {
        font-weight: 400;
        padding-right: 4px;
      }
    }
  }
  .empty {
    text-align: center;
    padding: 24px;
    color: #000;
    flex: 1;
    font-weight: 700;
    .homeLogo {
      padding: 0 16px 16px;
    }
  }
}
</style>
